var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import cxs from 'cxs/component';
class Icomoon extends Component {
    render() {
        const _a = this.props, { name } = _a, props = __rest(_a, ["name"]);
        return React.createElement(StyledIcon, Object.assign({}, props), name);
    }
}
export default Icomoon;
const StyledIcon = cxs('div')(({ size }) => ({
    display: 'inline-block',
    fontFamily: 'logo',
    fontSize: size ? size + 'px' : Theme.fontSize.big,
    textTransform: 'initial',
    lineHeight: 1,
    padding: Theme.size.space[1],
}));
StyledIcon.propTypes = {
    size: PropTypes.number
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Icomoon.tsx
// module id = 497
// module chunks = 0